module.exports = "/images/liverpool.svg?e4123943a9642eb6ba861d5077cc4cf6";